(function () {
  var GALLERY_ATTR = 'data-fancybox-gallery-id';

  var scriptTag = document.currentScript
    || document.querySelector('script[data-image-zoom][data-section-id]');
  var imageZoom = scriptTag ? scriptTag.getAttribute('data-image-zoom') : 'lightbox';

  if (imageZoom !== 'lightbox') return;

  function waitForFancybox(cb) {
    if (typeof Fancybox !== 'undefined') { cb(); return; }
    setTimeout(function () { waitForFancybox(cb); }, 80);
  }

  function getFancyboxOptions(startIndex) {
    return {
      startIndex: startIndex || 0,
      Thumbs: {
        type: 'classic',
      },
      Images: {
        zoom: true,
      },
      Zoom: {
        maxZoomPixelRatio: 6,
      },
      Toolbar: {
        display: {
          left: ['infobar'],
          middle: [],
          right: ['zoom', 'fullscreen', 'close'],
        },
      },
    };
  }

  function openAtMedia(galleryId, mediaId) {
    var links = Array.from(document.querySelectorAll('[data-fancybox="' + galleryId + '"]'));
    if (!links.length) return;

    var startIndex = 0;
    if (mediaId) {
      var idx = links.findIndex(function (el) {
        return el.getAttribute('data-media-id') === String(mediaId);
      });
      if (idx >= 0) startIndex = idx;
    }

    Fancybox.fromNodes(links, getFancyboxOptions(startIndex));
  }

  function interceptClicks() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('.product__modal-opener--image');
      if (!opener) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var productInfo = opener.closest('product-info, [data-section]');
      var sectionId = productInfo
        ? (productInfo.dataset.section || productInfo.dataset.originalSection)
        : null;

      var galleryId = sectionId
        ? 'product-gallery-' + sectionId
        : null;

      if (!galleryId) return;

      var mediaId = opener.getAttribute('data-media-id');
      openAtMedia(galleryId, mediaId);
    }, true);
  }

  function bindAllGalleries() {
    document.querySelectorAll('[' + GALLERY_ATTR + ']').forEach(function (container) {
      var galleryId = container.getAttribute(GALLERY_ATTR);
      Fancybox.bind('[data-fancybox="' + galleryId + '"]', getFancyboxOptions(0));
    });
  }

  waitForFancybox(function () {
    bindAllGalleries();
    interceptClicks();
  });
})();